module.exports = __webpack_public_path__ + "img/logo.81aea3eb.png";